import { render } from "./CourseItem.vue?vue&type=template&id=fec5337a"
import script from "./CourseItem.vue?vue&type=script&lang=js"
export * from "./CourseItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__